import Status from '@/components/Status.vue'
// import Conditions from '@/components/Conditions.vue'
import ConditionsMulti from '@/components/ConditionsMulti/ConditionsMulti.vue'

const routes = [
  {
    path: process.env.ROOT_PATH,
    component: Status,
    name: 'status'
  },
  {
    path: process.env.ROOT_PATH + 'status',
    component: Status,
    name: 'status'
  },
  // {
  //   path: process.env.ROOT_PATH + 'conditions',
  //   component: Conditions,
  //   name: 'conditions'
  // },
  {
    path: process.env.ROOT_PATH + 'conditions',
    component: ConditionsMulti,
    name: 'conditions'
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js